import INQUIRY_TYPES from "../../constants/inquiryTypes";

export default inquiryType => {
  switch (inquiryType) {
    case INQUIRY_TYPES.interested_seller:
      return "Interested In Selling?";
    case INQUIRY_TYPES.seller_landing_contact:
      return "Get the Inside Track";
    default:
      return "Questions about the StreetEasy Valuation?";
  }
};
